// extracted by mini-css-extract-plugin
module.exports = {"root":"_1IRDHcP5nFfwL7hyamm2db","label":"IYG-I2eAdtRaXedyuHWo_"};